import auth from '../services/auth'

const AppLayout = () => import('../components/AppLayout')
const Home = () => import('../components/HomeLayout')
const Dashboard = () => import('../components/DashboardLayout')
const Trainers = () => import('../components/TrainerList')
const BillingStatements = () => import('../components/BillingStatements')
const BillingStatementsTrainer = () => import('../components/BillingStatementsTrainer')
const SwornDeclarations = () => import('../components/SwornDeclarations')
const SwornDeclarationBulkUpload = () => import('../components/SwornDeclarationBulkUpload')
const Settings = () => import('../components/SettingList')
const FAQs = () => import('../components/FAQs')

const TrainerManual = () => import('../components/TrainerManual')

const Reports = () => import('../components/ReportList')

const User = () => import('@/components/UserList')
const UserEdit = () => import('@/components/UserEdit')

const FailedJobs = () => import('../components/FailedJobs')

// const Cycle = () => import('../components/Cycle')
const CyclesList = () => import('../components/CyclesList')
const AutomatedCyclesList = () => import('../components/AutomatedCyclesList')
const CycleView = () => import('../components/CycleView')
const CycleCreate = () => import('../components/CycleCreate')
const CycleEdit = () => import('../components/CycleEdit')
const CycleManageTrainers = () => import('../components/CycleManageTrainers')
// const CycleShow = () => import('../components/CycleShow')

const Company = () => import('../components/CompanyList')
const CompanyCreate = () => import('../components/CompanyCreate')
const CompanyEdit = () => import('../components/CompanyEdit')

const BillingStatus = () => import('../components/BillingStatus')

const FeeCategory = () => import('../components/FeeCategory')
const FeeCategoryCreate = () => import('../components/FeeCategory.Create')
const FeeCategoryEdit = () => import('../components/FeeCategory.Edit')

const Group = () => import('../components/GroupList')
const GroupCreate = () => import('../components/GroupCreate')
const GroupEdit = () => import('../components/GroupEdit')

const Permission = () => import('../components/PermissionList')
const PermissionCreate = () => import('../components/PermissionCreate')
const PermissionEdit = () => import('../components/PermissionEdit')

const Role = () => import('../components/RoleList')
const RoleCreate = () => import('../components/RoleCreate')
const RoleEdit = () => import('../components/RoleEdit')

const BillingFee = () => import('../components/BillingFee')
const BillingFeeCreate = () => import('../components/BillingFeeCreate')

const TrainerAdminRateCreate = () => import('../components/TrainerAdminRateCreate')
const TrainerAdminRateEdit = () => import('../components/TrainerAdminRateEdit')
const TrainerCycleCreate = () => import('../components/TrainerCycleCreate')
const TrainerCycleEdit = () => import('../components/TrainerCycleEdit')
const TrainerProfile = () => import('../components/TrainerProfile')
const Profile = () => import('../components/TrainerProfile')
const TrainerTaxStatusCreate = () => import('../components/TrainerTaxStatusCreate')
const TrainerTaxStatusEdit = () => import('../components/TrainerTaxStatusEdit')
const TrainerPetnetDetailsEdit = () => import('../components/TrainerPetnetDetailsEdit')

const BillingStatement = () => import('../components/BillingStatement')
const AcknowledgeReceipt = () => import('../components/AcknowledgeReceipt')

const AddendumFeesCreate = () => import('../components/AddendumFeesCreate')

const BankReport = () => import('@/components/BankReport')
const BankReportUpload = () => import('@/components/BankReportUpload')
const BankReportGenerate = () => import('@/components/BankReportGenerate')

const BIRTaxWithheldReport = () => import('@/components/BIRTaxWithheldReport')

const OfficialReceipt = () => import('@/components/OfficialReceipt')
const ORSample = () => import('@/components/ORSample')

const Audit = () => import('@/components/AuditReport')
const Console = () => import('@/components/ConsoleList')

/**
 * =======================================================================
 * App routes
 * =======================================================================
 *
 * Lazy loads component to initial page load improve performance.
 * Lazy load components are only loaded when a user is entering the route.
 * Access to this routes require user to be authenticated.
 *
 * =======================================================================
 */
export default {
  routes: [
    {
      name: 'OfficialReceiptSample',
      path: '/official-receipt-sample',
      component: ORSample,
      beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
    },
    {
      path: '/',
      component: Home,
      children: [
        {
          name: 'Console',
          path: '/console',
          component: Console,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Dashboard',
          path: '/',
          component: Dashboard,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * User Routes
         * --------------------------------------
         */
        {
          name: 'User',
          path: '/user',
          component: User,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'User Edit',
          path: '/user/:id/edit',
          component: UserEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * Trainer Routes
         * --------------------------------------
         */
        {
          name: 'Trainers',
          path: '/trainers',
          component: Trainers,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        {
          name: 'Profile',
          path: '/trainer/me',
          component: Profile,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * Billing Statement Routes
         * --------------------------------------
         */
        {
          name: 'Billing Statements',
          path: '/consultant-fees',
          component: BillingStatements,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Trainer Billing Statements',
          path: '/consultant-fees/me',
          component: BillingStatementsTrainer,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        {
          name: 'Sworn Declarations',
          path: '/sworn-declarations',
          component: SwornDeclarations,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'sworn-declaration-bulk-upload',
          path: '/sworn-declarations/bulk-upload',
          component: SwornDeclarationBulkUpload,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Settings',
          path: '/settings',
          component: Settings,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * Failed Jobs Routes
         * --------------------------------------
         */
        {
          name: 'FailedJobs',
          path: '/failed-jobs',
          component: FailedJobs,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * Company Routes
         * --------------------------------------
         */
        {
          name: 'Company',
          path: '/settings/company',
          component: Company,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Create Company Information',
          path: '/settings/company/create',
          component: CompanyCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Edit Company Information',
          path: '/settings/company/:id/edit',
          component: CompanyEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * FAQs Routes
         * --------------------------------------
         */
        {
          name: 'FAQs',
          path: '/faq/:slug?',
          component: FAQs,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * Billing Status Routes
         * --------------------------------------
         */
        {
          name: 'Billing Status',
          path: '/settings/billing-status',
          component: BillingStatus,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * Fee Category Routes
         * --------------------------------------
         */
        {
          name: 'Fee Category',
          path: '/settings/fee-category',
          component: FeeCategory,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Create Fee Category',
          path: '/settings/fee-category/create',
          component: FeeCategoryCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Edit Fee Category',
          path: '/settings/fee-category/:id/edit',
          component: FeeCategoryEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * Bank Report Route
         * --------------------------------------
         */
        {
          name: 'bankReports',
          path: '/bank-reports',
          component: BankReport,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * Report Route
         * --------------------------------------
         */
        {
          name: 'Reports',
          path: '/reports',
          component: Reports,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * Group Routes
         * --------------------------------------
         */
        {
          name: 'Group',
          path: '/settings/group',
          component: Group,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Create Group',
          path: '/settings/group/create',
          component: GroupCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Edit Group',
          path: '/settings/group/:id/edit',
          component: GroupEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * Permission Routes
         * --------------------------------------
         */
        {
          name: 'Permission',
          path: '/settings/permission',
          component: Permission,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Create Permission',
          path: '/settings/permission/create',
          component: PermissionCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Edit Permission',
          path: '/settings/permission/:id/edit',
          component: PermissionEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * Role Routes
         * --------------------------------------
         */
        {
          name: 'Role',
          path: '/settings/role',
          component: Role,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Create Role',
          path: '/settings/role/create',
          component: RoleCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'Edit Role',
          path: '/settings/role/:id/edit',
          component: RoleEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },

        /**
         * --------------------------------------
         * Billing Fee Routes
         * --------------------------------------
         */
        {
          name: 'Billing Fee',
          path: '/billing-fee',
          component: BillingFee,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * Official Receipt Routes
         * --------------------------------------
         */
        {
          name: 'Official Receipt',
          path: '/official-receipt',
          component: OfficialReceipt,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        /**
         * --------------------------------------
         * Audit Routes
         * --------------------------------------
         */
        {
          name: 'Audit',
          path: '/audit',
          component: Audit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'CyclesList',
          path: '/cycles',
          component: CyclesList,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'AutomatedCyclesList',
          path: '/settings/automated-cycles',
          component: AutomatedCyclesList,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    },
    /**
     * -------------------------------------
     * Bank Report Action Routes
     * -------------------------------------
     */
    {
      path: '/bank-report',
      component: AppLayout,
      redirect: {
        name: 'bankReports'
      },
      children: [
        {
          name: 'bankReportUpload',
          path: 'upload',
          component: BankReportUpload,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'bankReportGenerate',
          path: 'generate',
          component: BankReportGenerate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    },
    /**
     * --------------------------------------
     * Cycle Routes
     * --------------------------------------
     */
    {
      name: 'Cycle',
      path: '/cycle',
      component: AppLayout,
      redirect: {
        name: 'CycleView'
      },
      children: [
        {
          name: 'CycleCreate',
          path: 'create',
          component: CycleCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'CycleEdit',
          path: ':id/edit',
          component: CycleEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'CycleManageTrainers',
          path: ':id/manage-trainers',
          component: CycleManageTrainers,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'CycleView',
          path: ':id',
          component: CycleView,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    },
    {
      path: '/trainer',
      component: AppLayout,
      redirect: {
        name: 'TrainerProfile'
      },
      children: [
        {
          name: 'TrainerProfile',
          path: ':id',
          component: TrainerProfile,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'TrainerTaxStatusCreate',
          path: ':id/tax-status/create',
          component: TrainerTaxStatusCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'TrainerTaxStatusEdit',
          path: ':trainerID/tax-status/edit/:trainerTaxStatusID',
          component: TrainerTaxStatusEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'TrainerAdminRateCreate',
          path: ':trainerID/trainer-admin-rate/create',
          component: TrainerAdminRateCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'TrainerAdminRateEdit',
          path: ':trainerID/trainer-admin-rate/:trainerAdminRateID/edit',
          component: TrainerAdminRateEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'TrainerCycleCreate',
          path: ':trainerID/cycle/create',
          component: TrainerCycleCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'TrainerCycleEdit',
          path: ':trainerID/cycle/:trainerCycleID/edit',
          component: TrainerCycleEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'TrainerPetnetDetailsEdit',
          path: ':trainerID/petnet-details/edit',
          component: TrainerPetnetDetailsEdit,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'BillingFeeCreate',
          path: '/billing-fee/create',
          component: BillingFeeCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    },
    {
      name: 'BillingStatement',
      path: '/consultant-fee',
      component: AppLayout,
      redirect: {
        name: 'BillingStatementDetails'
      },
      children: [
        {
          name: 'BillingStatementDetails',
          path: ':id',
          component: BillingStatement,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        },
        {
          name: 'AcknowledgeReceipt',
          path: 'acknowledge-receipt/:id',
          component: AcknowledgeReceipt,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    },
    {
      name: 'AddendumFees',
      path: '/addendum-fees',
      component: AppLayout,
      redirect: {
        name: 'AddendumFeesCreate'
      },
      children: [
        {
          name: 'AddendumFeesCreate',
          path: 'create',
          component: AddendumFeesCreate,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    },
    {
      name: 'ViewBIRTaxWithheld',
      path: '/bir-reports',
      component: AppLayout,
      children: [
        {
          path: 'taxes-withheld/trainer_id/:trainerId/quarter/:quarter/year/:year',
          component: BIRTaxWithheldReport,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    },
    {
      name: 'TrainerManual',
      path: '/',
      component: AppLayout,
      children: [
        {
          path: 'trainer-manual',
          component: TrainerManual,
          beforeEnter: (to, from, next) => redirectIfNotLoggedIn(to, next)
        }
      ]
    }
  ]
}

/**
 * Only authenticated users are allowed to enter the route.
 *
 * @param next
 */
async function redirectIfNotLoggedIn (to, next) {
  const access = auth.getAuth()

  auth.requestedPage = to.fullPath

  if (!access) return next('/login')

  const verified = await auth
    .verifyAccessToken()
    .then(({ data }) => {
      auth.setUser(data)
      return data
    })
    .catch(() => auth.flush())

  return verified ? next() : next('/login')
}

